import React from "react";
import { SelectInput } from "react-admin";

interface Props {
  source: string;
}
const ProductTypeInput: React.FC<Props> = (props) => {
  const isSR = process.env.REACT_APP_COMPANY_CODE === "SNR";

  const instrumentChoices = isSR
    ? [
        { id: "instrument", name: "Device" },
        { id: "implant", name: "Consumable" },
        { id: "others", name: "Others" },
      ]
    : [
        { id: "instrument", name: "Instrument" },
        { id: "implant", name: "Implant" },
        { id: "others", name: "Others" },
      ];

  return <SelectInput {...props} choices={instrumentChoices} />;
};

export default ProductTypeInput;
